module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_24.c1aff5ba.jpg";